import React, { useState } from 'react';
import './approvalretrival.css'; // Import the CSS file

const ExpenseApprovalPage = () => {
  const [approvalData, setApprovalData] = useState([]); // To hold the fetched data
  const [error, setError] = useState(''); // For handling any error

  // Function to fetch the approval data from the backend
  const fetchApprovalData = async () => {
    try {
      const response = await fetch('https://cleezoclass.com:8443/api/getApprovalData');
      if (!response.ok) {
        throw new Error('Failed to fetch approval data');
      }
      const data = await response.json();
      setApprovalData(data.data); // Set the fetched data to the state
    } catch (err) {
      setError(err.message); // Set the error message
    }
  };

  return (
    <div className="approval-container">
      <h2>Expense Approval Data</h2>

      {/* Button to fetch data */}
      <button onClick={fetchApprovalData}>View Response</button>

      {/* Show error if any */}
      {error && <p className="error-message">{error}</p>}

      {/* Table to display fetched data */}
      {approvalData.length > 0 && (
        <div className="approval-table-container">
          <table>
            <thead>
              <tr>
                <th>ID</th>
                <th>Emp ID</th>
                <th>Approval Status</th>
                <th>Category</th> {/* Added category column */}
                <th>Updated At</th>
              </tr>
            </thead>
            <tbody>
              {approvalData.map((item, index) => (
                <tr key={index}>
                  <td>{item.id}</td>
                  <td>{item.empId}</td>
                  <td>{item.approvalStatus}</td>
                  <td>{item.category || 'N/A'}</td> {/* Display category */}
                  <td>{new Date(item.updatedAt).toLocaleString()}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default ExpenseApprovalPage;
